import React from 'react';

const CaseTitle = (props) => (
    <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <div className={"PageHeader"}>{props.caseName}</div>
        {props.children}
    </div>
);


export default CaseTitle;


// WEBPACK FOOTER //
// ./src/common/components/CaseTitle.js